'use strict';

export default class QuantityControl {
	constructor(root) {
        this.root = root;
        if (!this.root) return;

        this.input = this.root.querySelector("[data-quantity-control-input]");
        this.buffer = this.root.querySelector("[data-quantity-control-buffer]");

        this._init();
    }
    
    _init() {
        this.input.addEventListener("input", this.refresh.bind(this));
        this.input.addEventListener("change", this.refresh.bind(this));
        this.refresh();
    }

    refresh() {
        this.buffer.innerText = this.input.value;
        $(this.input).width($(this.buffer).width());
    }

    setValue(value) {
        this.input.value = value;
    }
}
